<template>
  <JyDialog :visible.sync="visible" :title="editTitle" max-width="800px" :before-close="onDialogClose" moveable :activatedLoad="getData" ref="editDialog">
    <el-form v-loading="editLoading" :model="editData" :rules="rules" label-width="120px" size="small" ref="editForm">
      <el-row type="flex" class="flex-wrap">
        <form-item label="上传投稿" fill="4">
          <el-upload
            class="avatar-uploader company-uploader"
            :headers="headers"
            :action="uploadPic"
            :data="{needoldname: true}"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            accept=".docx,.doc"
            multiple
          >
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="d-flex flex-column">
            <div v-for="(item, index) in fileList" :key="index" class="mr-2">
              <a :href="rootPath + item" target="hyjy_download" download>{{ item }}</a>
              <JyButton class="ml-2 text-danger" is-a @click.stop="delFile(item, 1, index)">删除文件</JyButton>
            </div>
          </div>
        </form-item>
        <form-item label="稿件名称" prop="name" fill="4">
          <el-input v-model="editData.name" placeholder="稿件名称" ref="form.name" clearable></el-input>
        </form-item>
        <form-item label="投稿单位" prop="name" fill="4">
          <el-select v-loading="loading.tgdwList" v-model="editData.tgdw" filterable>
            <template v-for="item in tgdwList">
              <jy-option :label="item.name" :value="item.id" :key="item.id" :ext-label="item.code">
                <div class="d-flex">
                  <div>{{ item.name }}</div>
                  <div class="ml-auto text-muted">{{ item.code }}</div>
                </div>
              </jy-option>
            </template>
          </el-select>
        </form-item>
        <form-item label="投稿时间" prop="updatetime" fill="4">
          <el-date-picker
            v-model="editData.updatetime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择投稿时间">
          </el-date-picker>
        </form-item>
        <form-item label="稿件数" prop="num" fill="4">
          <div>{{ fileList.length }}</div>
        </form-item>
      </el-row>
    </el-form>
    <div slot="footer">
      <JyButton type="secondary" icon="times" class="mr-2" @click="doClose">关闭</JyButton>
      <JyButton type="success" icon="save" :disabled="!needsave" @click="doSave">保存</JyButton>
    </div>
  </JyDialog>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from 'jystore/mutation-types';
import tools from 'jyutils/tools';
export default {
  name: 'TougaoAdd',
  mixins: [tools],
  props: {
    id: String
  },
  data() {
    return {
      visible: false,
      editLoading: false,
      fileList: [],
      rules: {
        name: {required:true, message:'名称必填！'},
        file: {required:true, message:'请上传文件！'},
        updatetime: {required:true, message:'请输入投稿时间！'},
      },
    }
  },
  computed: {
    ...mapGetters({
      tgdwList: [types.BASE_LOAD.tgdwList],
      loading: [types.BASE_LOAD.baseLoading]
    }),
    editTitle() {
      return '上传投稿';
    },
    pickerOptions0() {
      return  {
        disabledDate(time) {
          return time.getTime() <= Date.now() - 86400000;
        }
      }
    },
    defaultData() {
      return {
        id: null, name: null, file: null, updatetime:null
      }
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.getData();
      }
    },
  },
  methods: {
    show(flag) {
      this.visible = flag ? true : false;
    },
    getData() {
      this.editLoading = true;
      this.editData = {itemList: []};
      if (this.id) {
        this.doGet({
          url: 'sys/tougao/getItem/'+ this.id,
          okcb: (json) => {
            this.editData = Object.assign({}, json);
            this.initEditData();
          }
        });
      } else {
        if (this.leaveData) {
          this.editData = JSON.parse(this.leaveData);
        } else {
          this.editData = Object.assign({}, this.defaultData, {updatetime: this.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss')});
        }
        this.initEditData();
      }
      if (!this.tgdwList || !this.tgdwList.length) {
        this.$store.dispatch(types.BASE_LOAD.tgdwList);
      }
    },
    initEditData() {
      this.fileList = [];
      this.$nextTick(() => this.editLoading = false);
      // set origin data for check modified
      this.setOriaData();
    },
    handleUploadSuccess(res, file, filelist) {
      if (res.obj && res.obj.pic) {
        this.fileList.push(res.obj.pic);
        if (!this.editData.name) {
          this.editData.name = res.obj.pic.substring(res.obj.pic.lastIndexOf('/') + 1, res.obj.pic.lastIndexOf('.'));
        }
        this.editData.file = this.fileList.join(',');
        filelist.forEach(d => {
          if (d.status == 'success') {
            filelist.splice(filelist.indexOf(d), 1);
          }
        });

        // filelist.length = 0;
      } else {
        this.$message.error(res.message || '上传出错啦！');
      }
    },
    delFile(file, index) {
      this.msgbox(`确定要删除该文件吗？`, () => {
        this.$message.success('删除成功！');
        this.fileList.splice(index, 1);
        this.editData.file = this.fileList.join(',');
      });
    },
    doSave() {
      this.submitform().then(() => {
        let postData = Object.assign({}, this.editData);
        
        postData.file = this.fileList.join(',');
        postData.num = this.fileList.length;

        this.saveLoading = true;
        this.doPost({
          url: 'sys/tougao/saveItem',
          data: postData,
          okcb: () => {
            this.$message.success('保存成功！');
            this.$emit('save');
            // 跳转
            this.setOriaData(0, () => {
              this.visible = false;
              this.fileList = [];
            });
          },
          cb: () => {
            this.saveLoading = false;
          }
        });
      }).catch(() => {});
    },
    onDialogClose(done) {
      let doConfirm = () => {
        done();
      }

      this.confirmSave(`还未保存，确定要离开吗？`, doConfirm);
    },
    doClose() {
      this.$refs.editDialog.handleClose();
    }
  }
}
</script>